<template>
  <div>

          <IntroText
            :intro-one="pageItem.ShortText"
            :pageItem="pageItem"
            :showForm =false
          />

          <v-container>
          <v-row>
            <v-col cols="12" sm="6">
              <h2 class="pb-1"> {{ siteSettings.FooterLocationName }}</h2>
              <v-row>
                <v-col cols="6" class="d-flex flex-column">
                  <a class="text-none text-decoration-none">
                    <p class="pb-0"> {{ siteSettings.FooterStreetHouseNumber }} </p>
                    <p class="pt-1 pb-2"> {{ siteSettings.FooterZipcodeCity }} </p>
                  </a>
                  <a :href="'mailto:' + siteSettings.FooterEmail" class="text-none text-decoration-none">
                    <p class="pb-0">
                      <SvgIconPublic class="mr-1" :url="siteSettings.IconMail" :sizeIcon="25"/>
                      {{ siteSettings.FooterEmail }}
                    </p>
                  </a>
                  <v-sheet class="pb-3">
                    <a :href="'tel:' + siteSettings.FooterTelephone" class="text-none text-decoration-none">
                      <p class="pt-1">
                        <SvgIconPublic class="mr-1" :url="siteSettings.IconTelephone" :sizeIcon="25"/>
                        {{ siteSettings.FooterTelephone }}
                      </p>
                    </a>
                  </v-sheet>
                </v-col>
              </v-row>
              <v-row>
                    <v-col cols="6" class="d-flex flex-column">
                  <div v-if="siteSettings.FooterOpeningTimeTitle">
                    <h3>{{ siteSettings.FooterOpeningTimeTitle }}</h3>
                    <span >
                      <span v-for="(Item, index) in openingTimes" :key="index">
                      <span v-if="Item.Descriptioin == 'Gesloten'"> </span>
                      <span v-else class="nostyletable">
                        <table density="compact" class="py-0">
                          <thead>
                            <tr v-if="Item.HolidayName">
                              <td class="text-left" style="width: 90px">
                                {{ Item.DayName }}
                              </td>
                              <td style="width: 100px" v-text="Item.HolidayName">
                              </td>
                            </tr>
                            <tr v-else-if="Item.Closed">
                              <td class="text-left" style="width: 90px">
                                {{ Item.DayName }}
                              </td>
                              <td style="width: 100px" v-text="Item.Closed">
                              </td>
                            </tr>
                            <tr v-else :class="{ 'current-day': isCurrentDay(index) }" >
                              <td class="text-left" style="width: 90px">
                                {{ Item.DayName }}
                              </td>
                              <td class="text-left" style="width: 35px" v-text="Item.TimeOpen"></td>
                              <td class="text-left px-1" style="width: 15px">-</td>
                              <td style="width: 39px" v-text="Item.TimeClosed">
                              </td>
                            </tr>
                          </thead>
                        </table>
                      </span>
                      </span>
                    </span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                    <v-col cols="12" class="d-flex flex-column">
                  <div v-if="siteSettings.FooterHolidayTitle && holidays && holidays.length>0">
                      <h3>{{ siteSettings.FooterHolidayTitle }}</h3>
                      <v-table density="compact" class="py-0">

                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(holiday, index) in holidays" :key="index" :class="{ 'current-day': isCurrentDate(holiday.Date) }">
                          <td class="text-left" >
                            {{ holiday.DayName }}
                          </td>
                          <td class="text-left" >
                            {{ holiday.Date }}
                          </td>
                          <td class="text-left" > {{ holiday.HolidayName }}</td>
                        </tr>
                    </tbody>
                      </v-table>
                  </div>



                </v-col>


              </v-row>
             <v-row no-gutters class="pa-0 fill-height">
                <v-col cols="12">
                  <div class="font-weight-bold py-0 pr-3">
                    {{ siteSettings.FooterSocialMediaTitle }}
                  </div>
                  <a
                    v-for="(icon, index) in itemsCombined"
                    :key="index"
                    :href="icon.SocialLink"
                    target="_blank"
                    class="text-none text-decoration-none footerbar1icon mr-2"
                  >
                    <SvgIconPublic :sizeIcon="42" :url="icon.SocialIcon" />
                  </a>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6">
              <JSONForm v-if="pageItem.formData" :formData="pageItem.formData" />
            </v-col>
          </v-row>
          </v-container>

          <IntroText
            :intro-one="pageItem.MainText"
            :pageItem="pageItem"
            :showForm =false
          />

  </div>
</template>
<style scoped>
.current-day {
  font-weight: bold;
}
</style>

<script setup>
import IntroText from "@/components/Base/introText.vue";
import JSONForm from '@/components/JSONForm/form.vue'
import SvgIconPublic from "@/components/Base/SvgIconPublic.vue";
import { useSiteSettingsStore } from "../../store/siteSettings";
const { $helpers } = useNuxtApp()
let FooterSocial = [];
const siteSettings = useSiteSettingsStore();
const props = defineProps({
  pageItem: {
    type: Object,
    default: "",
  },
});

// Gebruik
const holidays = computed(() => {
  return sortOnDate(siteSettings.Holidays);
});

const openingTimes = computed(() => {
  return sortOnDate(siteSettings.OpeningTime);
});
function isCurrentDate(date) {

  const today = new Date();
  const dateToday = `${today.getDate().toString().padStart(2, '0')}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getFullYear()}`;
  return date === dateToday;
}

function isCurrentDay(index) {
      const today = (new Date().getDay() + 6) % 7; // sunday => 6, monday => 0
      return index === today;
}


const itemsCombined = computed(() => {
  var FooterSocial = [];
  if (
    $helpers.isset(siteSettings["FooterIconFacebookUrl"]) &&
    siteSettings["FooterIconFacebookUrl"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconFacebook, //'Facebook',
      SocialLink: siteSettings["FooterIconFacebookUrl"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterIconLinkedinUrl"]) &&
    siteSettings["FooterIconLinkedinUrl"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconLinkedin,//'LinkedIn',
      SocialLink: siteSettings["FooterIconLinkedinUrl"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterIconYoutubeUrl"]) &&
    siteSettings["FooterIconYoutubeUrl"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconYoutube,//'Youtube',
      SocialLink: siteSettings["FooterIconYoutubeUrl"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterIconWhatsapp"]) &&
    siteSettings["FooterIconWhatsapp"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconWhatsapp,//'Whatsapp',
      SocialLink: 'https://wa.me/'+siteSettings["FooterWhatsapp"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterIconInstagramUrl"]) &&
    siteSettings["FooterIconInstagramUrl"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconInstagram,//'Insta',
      SocialLink: siteSettings["FooterIconInstagramUrl"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterIconTiktok"]) &&
    siteSettings["FooterIconTiktok"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconTiktok,//'Tik Tok',
      SocialLink: siteSettings["FooterIconTiktokUrl"],
    });
  }

  return FooterSocial;
});

const iconSize = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 24;
    case "sm":
      return 26;
    case "md":
      return 29;
    case "lg":
      return 30;
    case "xl":
      return 40;
    case "xxl":
      return 40;
    default:
      return 24;
  }
});
</script>
